import { render } from "./LaborersAttendanceLabel.vue?vue&type=template&id=2ce86fc8"
import script from "./LaborersAttendanceLabel.vue?vue&type=script&lang=js"
export * from "./LaborersAttendanceLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/laborers/attendance/result/LaborersAttendanceLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ce86fc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ce86fc8', __exports__)) {
    api.reload('2ce86fc8', __exports__)
  }
  
  module.hot.accept("./LaborersAttendanceLabel.vue?vue&type=template&id=2ce86fc8", () => {
    api.rerender('2ce86fc8', render)
  })

}


export default __exports__